import { render } from "./ShowQuestions.vue?vue&type=template&id=dd8b46dc"
import script from "./ShowQuestions.vue?vue&type=script&lang=js"
export * from "./ShowQuestions.vue?vue&type=script&lang=js"

import "./ShowQuestions.vue?vue&type=style&index=0&id=dd8b46dc&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__